import { useTranslation } from 'react-i18next'

import { CriteoIcon } from 'app/common/presentation/icons'

import styles from './AuthorizationButton.module.scss'

const CriteoLogin = () => {
  const { t } = useTranslation('connections')
  return (
    <div className={styles.criteo}>
      <div>
        <CriteoIcon />
        <span>{t('setup.authorization.criteo.signIn')}</span>
      </div>
    </div>
  )
}

export default CriteoLogin
